export const HALF_SECOND = 500; // 0.5 second = 500 ms

export const ONE_SECOND = 1000; // 1 second = 1000 ms
export const TWO_SECONDS = 2000; // 2 seconds = 2000 ms
export const TEN_SECONDS = 10000; // 10 seconds = 10,000 ms
export const TWENTY_FIVE_SECONDS = 25000; // 25 seconds = 25,000 ms
export const THIRTY_SECONDS = 30000; // 30 seconds = 30,000 ms
export const FORTY_FIVE_SECONDS = 45000; // 45 seconds = 45,000 ms

export const ONE_MINUTE = 60000; // 1 minute = 60,000 ms
export const FIVE_MINUTES = 300000; // 5 minutes = 300,000 ms
export const TEN_MINUTES = 600000; // 10 minutes = 600,000 ms
export const FIFTEEN_MINUTES = 900000; // 15 minutes = 900,000 ms

export const ONE_HOUR = 3600000; // 1 hour = 3,600,000 ms

export const MANITOBA_TIMEZONE = "America/Winnipeg";

export const MINUTES_IN_HOUR = 60;
